/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { TourStop } from 'src/app/_model/tour-stop';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class TourStopsDaoService implements Resetable {
  public abstract saveTourStops(tourStops: TourStop[]): Promise<void>;
  public abstract getTourStops(): Promise<TourStop[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}